import { Blockquote } from '@mantine/core';
import { AlertCircle, Info, XCircle } from 'lucide-react';
import { FC, ReactElement } from 'react';

import { EternoQuoteVariant } from '@/models/EternoQuoteVariant.ts';

interface Props {
    text: string;
    variant?: EternoQuoteVariant;
}

const iconMap: Record<EternoQuoteVariant, ReactElement> = {
    [EternoQuoteVariant.INFO]: <Info />,
    [EternoQuoteVariant.WARNING]: <AlertCircle />,
    [EternoQuoteVariant.ERROR]: <XCircle />,
};

const EternoQuote: FC<Props> = ({ text, variant = EternoQuoteVariant.INFO }) => {
    return (
        <Blockquote
            classNames={{
                root: 'p-5',
            }}
            color={variant}
            icon={iconMap[variant]}
            iconSize={40}
        >
            {text}
        </Blockquote>
    );
};

export default EternoQuote;
